var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',{staticClass:"vehicle-list",attrs:{"title":"Kunder"}},[_c('new-table-view',{ref:"table",attrs:{"columns":[
		{
			label: 'Kunde',
			name: 'name'
		},
		{
			label: 'Adresse',
			name: 'address'
		},
		{
			label: 'Postnr.',
			name: 'zip'
		},
		{
			label: 'By',
			name: 'city'
		},
		{
			label: 'Telefon',
			name: 'phone'
		},
		{
			label: 'E-email',
			name: 'email'
		}
	],"items":_vm.items,"pagination":_vm.pagination},on:{"itemClick":_vm.itemClick},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('pagination-bar-view',{staticStyle:{"padding":"10px 10px 10px 10px"},attrs:{"pagination":_vm.pagination},on:{"update:pagination":function($event){_vm.pagination=$event}}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }